import Panel from '../../../../components/UI/Panel';
import { Box, FormControl, Grid, Typography } from '@mui/material';
import CheckboxInput from '../UI/CheckboxInput';
import GenericInput from '../UI/GenericInput';
import UploadFilesComponent from '../UI/UploadFilesComponent';
import {
  acceptedFileUploadTypes,
  maximumUploadFileSize,
} from '../../../../settings/appConfig';
import { useEffect, useRef, useState } from 'react';
import { FilePondFile } from 'filepond';
import uploadFilesStyles from '../../../../assets/styles/uploadFilesStyles';
import uploadIcon from '../../../../assets/Icons/uploadicon.svg';
import GenericSelectInput from '../UI/GenericSelectInput';
import DepartmentEditOldFiles from './DepartmentEditOldFiles';

export default function DepartmentServePreferencesDocumentsInfo({
  form,
  departmentFileTypes,
}: {
  form: any;
  departmentFileTypes: any[];
}) {
  const [isBusy, setIsBusy] = useState<boolean>(false);
  const previousFormFilesRef = useRef(
    form?.values?.custodianDetails?.servePreferences?.files,
  );
  useEffect(() => {
    previousFormFilesRef.current =
      form?.values?.custodianDetails?.servePreferences?.files;
  }, [form?.values?.custodianDetails?.servePreferences?.files]);

  const updateFormFiles = (pondFiles: FilePondFile[]) => {
    const safePondFiles = pondFiles ?? [];

    form?.setFieldValue(`custodianDetails.servePreferences.files`, 
      safePondFiles.map((f) => {
        let file = f.file as any;

        const safePreviousFiles = previousFormFilesRef.current ?? [];

        const oldFileIndex = safePreviousFiles.findIndex(
          (formFile: { id: string }) => formFile.id === f.id,
        );

        if (oldFileIndex > -1) {
          return {
            ...safePreviousFiles[oldFileIndex],
            tempBlobUrl: file.url?.substring(0, file.url.indexOf('?')) ?? '',
          };
        } else {
          return {
            id: f.id,
            name: file.name,
            typeId: '',
            tempBlobUrl: file.url?.substring(0, file.url.indexOf('?')) ?? '',
            fileSize: file.size ?? 0,
            pondFile: f,
          };
        }
      })
    );
  };

  const autoCheckServePreferencesFields = (typeId: number) => {
    let fileTypeName = departmentFileTypes
      .find((ft) => ft.id === typeId)
      ?.name?.toLowerCase();
    switch (fileTypeName) {
      case 'accept lor':
        form.setFieldValue(
          `custodianDetails.servePreferences.isAcceptLOR`,
          true,
        );
        break;
      case 'copy service':
        form.setFieldValue(
          `custodianDetails.servePreferences.isCopyService`,
          true,
        );
        break;
      case 'facility specific authorization':
        form.setFieldValue(
          `custodianDetails.servePreferences.isFacilitySpecificAuthorization`,
          true,
        );
        break;
      case 'additional facility specific documentation':
        form.setFieldValue(
          `custodianDetails.servePreferences.isAdditionalFacilitySpecificDocumentation`,
          true,
        );
        break;
      default:
        break;
    }
  };

  const getFileTypeDevHeight = (file: FilePondFile, index: number) => {
    if (file) {
      let itemHeight = Number(
        (
          window.document.getElementById(`filepond--item-${file.id}`)?.style
            .height ?? '50px'
        ).substring(0, 2),
      );
      return `${
        index ===
        form?.values?.custodianDetails?.servePreferences?.files.length - 1
          ? itemHeight + 7
          : itemHeight + 10
      }px`;
    }
  };

  const getFileTypeControleHeight = (file: FilePondFile) => {
    if (file) {
      let itemHeight = Number(
        (
          window.document.getElementById(`filepond--item-${file.id}`)?.style
            .height ?? '50px'
        ).substring(0, 2),
      );
      return `${itemHeight}px`;
    }
  };

  return (
    <Panel headerText="Documents">
      <Grid container>
        <Grid item xs={6}>
          <Grid item xs={12}>
            <CheckboxInput
              label="Authorization with Subpoena Required"
              keyName={`${form}.values.custodianDetails.servePreferences.isAuthorizationWithSubpoenaRequired`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isAuthorizationWithSubpoenaRequired
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isAuthorizationWithSubpoenaRequired`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isAuthorizationWithSubpoenaRequired`,
                  true,
                );
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="POA for Subpoena"
              keyName={`${form}.values.custodianDetails.servePreferences.isPOAForSubpoena`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isPOAForSubpoena
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isPOAForSubpoena`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isPOAForSubpoena`,
                  true,
                );
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="HIPPA Authorization Original"
              keyName={`${form}.values.custodianDetails.servePreferences.isHIPPAAuthorizationOriginal`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isHIPPAAuthorizationOriginal
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isHIPPAAuthorizationOriginal`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isHIPPAAuthorizationOriginal`,
                  true,
                );
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="Facility Specific Authorization"
              keyName={`${form}.values.custodianDetails.servePreferences.isFacilitySpecificAuthorization`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isFacilitySpecificAuthorization
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isFacilitySpecificAuthorization`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isFacilitySpecificAuthorization`,
                  true,
                );
              }}
            />
            {form?.values?.custodianDetails?.servePreferences
              ?.isFacilitySpecificAuthorization ? (
              <GenericInput
                name="facilitySpecificAuthorizationNotes"
                label="Facility Specific Authorization Notes"
                placeholder="Notes"
                key={`${form}.values.custodianDetails.servePreferences.facilitySpecificAuthorizationNotes`}
                maxLength={150}
                value={
                  form?.values?.custodianDetails?.servePreferences
                    ?.facilitySpecificAuthorizationNotes
                }
                onChange={(e: any) => {
                  form.setFieldValue(
                    `custodianDetails.servePreferences.facilitySpecificAuthorizationNotes`,
                    e.target.value,
                  );
                }}
                onBlur={() => {
                  form.setFieldTouched(
                    `custodianDetails.servePreferences.facilitySpecificAuthorizationNotes`,
                    true,
                  );
                }}
                errorMsg={
                  form?.touched?.custodianDetails?.servePreferences
                    ?.facilitySpecificAuthorizationNotes &&
                  form?.errors?.custodianDetails?.servePreferences
                    ?.facilitySpecificAuthorizationNotes
                    ? form?.errors?.custodianDetails?.servePreferences
                        ?.facilitySpecificAuthorizationNotes
                    : ''
                }
                hasError={
                  !!(
                    form?.touched?.custodianDetails?.servePreferences
                      ?.facilitySpecificAuthorizationNotes &&
                    form?.errors?.custodianDetails?.servePreferences
                      ?.facilitySpecificAuthorizationNotes
                  )
                }
              />
            ) : (
              ''
            )}
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Death Certificate"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresDeathCertificate`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresDeathCertificate
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresDeathCertificate`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresDeathCertificate`,
                  true,
                );
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Certification of Non-Objection"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresCertificationOfNonObjection`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresCertificationOfNonObjection
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresCertificationOfNonObjection`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresCertificationOfNonObjection`,
                  true,
                );
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Third Party Listed on Auth/Subpoena"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresThirdPartyListedOnAuthSubpoena`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresThirdPartyListedOnAuthSubpoena
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresThirdPartyListedOnAuthSubpoena`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresThirdPartyListedOnAuthSubpoena`,
                  true,
                );
              }}
            />
          </Grid>
        </Grid>

        <Grid item xs={6} pl={3}>
          <Grid item xs={12}>
            <CheckboxInput
              label="Accept LOR"
              keyName={`${form}.values.custodianDetails.servePreferences.isAcceptLOR`}
              checked={
                form?.values?.custodianDetails?.servePreferences?.isAcceptLOR
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isAcceptLOR`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isAcceptLOR`,
                  true,
                );
              }}
            />

            {form?.values?.custodianDetails?.servePreferences?.isAcceptLOR ? (
              <GenericInput
                name="acceptLORNotes"
                label="Accept LOR Notes"
                placeholder="Notes"
                key={`${form}.values.custodianDetails.servePreferences.acceptLORNotes`}
                maxLength={150}
                value={
                  form?.values?.custodianDetails?.servePreferences
                    ?.acceptLORNotes
                }
                onChange={(e: any) => {
                  form.setFieldValue(
                    `custodianDetails.servePreferences.acceptLORNotes`,
                    e.target.value,
                  );
                }}
                onBlur={() => {
                  form.setFieldTouched(
                    `custodianDetails.servePreferences.acceptLORNotes`,
                    true,
                  );
                }}
                errorMsg={
                  form?.touched?.custodianDetails?.servePreferences
                    ?.acceptLORNotes &&
                  form?.errors?.custodianDetails?.servePreferences
                    ?.acceptLORNotes
                    ? form?.errors?.custodianDetails?.servePreferences
                        ?.acceptLORNotes
                    : ''
                }
                hasError={
                  !!(
                    form?.touched?.custodianDetails?.servePreferences
                      ?.acceptLORNotes &&
                    form?.errors?.custodianDetails?.servePreferences
                      ?.acceptLORNotes
                  )
                }
              />
            ) : (
              ''
            )}
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="SOA for Subpoena"
              keyName={`${form}.values.custodianDetails.servePreferences.isSOAForSubpoena`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isSOAForSubpoena
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isSOAForSubpoena`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isSOAForSubpoena`,
                  true,
                );
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="Copy Service"
              keyName={`${form}.values.custodianDetails.servePreferences.isCopyService`}
              checked={
                form?.values?.custodianDetails?.servePreferences?.isCopyService
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isCopyService`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isCopyService`,
                  true,
                );
              }}
            />
            {form?.values?.custodianDetails?.servePreferences?.isCopyService ? (
              <GenericInput
                name="CopyServiceNotes"
                label="Copy Service Notes"
                placeholder="Copy Service Notes"
                maxLength={150}
                value={
                  form?.values?.custodianDetails?.servePreferences
                    ?.copyServiceNotes
                }
                onChange={(e: any) => {
                  form.setFieldValue(
                    `custodianDetails.servePreferences.copyServiceNotes`,
                    e.target.value,
                  );
                }}
                onBlur={() => {
                  form.setFieldTouched(
                    `custodianDetails.servePreferences.copyServiceNotes`,
                    true,
                  );
                }}
                errorMsg={
                  form?.touched?.custodianDetails?.servePreferences
                    ?.copyServiceNotes &&
                  form?.errors?.custodianDetails?.servePreferences
                    ?.copyServiceNotes
                    ? form?.errors?.custodianDetails?.servePreferences
                        ?.copyServiceNotes
                    : ''
                }
                hasError={
                  !!(
                    form?.touched?.custodianDetails?.servePreferences
                      ?.copyServiceNotes &&
                    form?.errors?.custodianDetails?.servePreferences
                      ?.copyServiceNotes
                  )
                }
              />
            ) : (
              ''
            )}
          </Grid>

          <Grid item xs={12}>
            <CheckboxInput
              label="Additional Facility Specific Documentation"
              keyName={`${form}.values.custodianDetails.servePreferences.isAdditionalFacilitySpecificDocumentation`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isAdditionalFacilitySpecificDocumentation
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isAdditionalFacilitySpecificDocumentation`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isAdditionalFacilitySpecificDocumentation`,
                  true,
                );
              }}
            />
            {form?.values?.custodianDetails?.servePreferences
              ?.isAdditionalFacilitySpecificDocumentation ? (
              <GenericInput
                name="additionalFacilitySpecificDocumentationNotes"
                label="Additional Facility Specific Documentation Notes"
                placeholder="Additional Facility Specific Documentation Notes"
                maxLength={150}
                value={
                  form?.values?.custodianDetails?.servePreferences
                    ?.additionalFacilitySpecificDocumentationNotes
                }
                onChange={(e: any) => {
                  form.setFieldValue(
                    `custodianDetails.servePreferences.additionalFacilitySpecificDocumentationNotes`,
                    e.target.value,
                  );
                }}
                onBlur={() => {
                  form.setFieldTouched(
                    `custodianDetails.servePreferences.additionalFacilitySpecificDocumentationNotes`,
                    true,
                  );
                }}
                errorMsg={
                  form?.touched?.custodianDetails?.servePreferences
                    ?.additionalFacilitySpecificDocumentationNotes &&
                  form?.errors?.custodianDetails?.servePreferences
                    ?.additionalFacilitySpecificDocumentationNotes
                    ? form?.errors?.custodianDetails?.servePreferences
                        ?.additionalFacilitySpecificDocumentationNotes
                    : ''
                }
                hasError={
                  !!(
                    form?.touched?.custodianDetails?.servePreferences
                      ?.additionalFacilitySpecificDocumentationNotes &&
                    form?.errors?.custodianDetails?.servePreferences
                      ?.additionalFacilitySpecificDocumentationNotes
                  )
                }
              />
            ) : (
              ''
            )}
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Estate Letter"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresEstateLetter`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresEstateLetter
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresEstateLetter`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresEstateLetter`,
                  true,
                );
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Certification of Notice"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresCertificationOfNotice`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresCertificationOfNotice
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresCertificationOfNotice`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresCertificationOfNotice`,
                  true,
                );
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CheckboxInput
              label="Requires Record Type and Scope in Auth"
              keyName={`${form}.values.custodianDetails.servePreferences.isRequiresRecordTypeAndScopeInAuth`}
              checked={
                form?.values?.custodianDetails?.servePreferences
                  ?.isRequiresRecordTypeAndScopeInAuth
              }
              onChange={(e: any) => {
                form.setFieldValue(
                  `custodianDetails.servePreferences.isRequiresRecordTypeAndScopeInAuth`,
                  e.target.checked,
                );
              }}
              onBlur={() => {
                form.setFieldTouched(
                  `custodianDetails.servePreferences.isRequiresRecordTypeAndScopeInAuth`,
                  true,
                );
              }}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} pt={2}>
          <DepartmentEditOldFiles form={form} />
        </Grid>
        <Grid item xs={1.5}></Grid>

        <Grid item xs={9} sx={uploadFilesStyles.wrapperstyles}>
          <Grid item xs={3} sx={uploadFilesStyles.headerStyles}>
            <Box
              data-testid="uploadIcon"
              height={'25px'}
              width={'25px'}
              sx={uploadFilesStyles.uploadIconStyles}
            >
              <img src={uploadIcon} width={'25px'} height={'25px'} />
            </Box>
            <Typography sx={uploadFilesStyles.headerTextStyles}>
              Upload Files
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            className="file-panal"
            sx={uploadFilesStyles.filePanelStyles}
            alignItems="flex-end"
          >
            <Grid item xs={8}>
              <UploadFilesComponent
                keyName={`fileUploader.servepreference`}
                setIsBusy={setIsBusy}
                acceptMultipleFiles={true}
                maxNumberOfFiles={10}
                updateFormFiles={updateFormFiles}
                fileTypes={acceptedFileUploadTypes}
                initialFiles={form?.values?.custodianDetails?.servePreferences?.files?.map(
                  (f: { pondFile: any }) => f.pondFile,
                )}
                maxFileSize={maximumUploadFileSize}
              ></UploadFilesComponent>
            </Grid>
            <Grid item xs={4} className="file-type">
              {form?.values?.custodianDetails?.servePreferences?.files.length >
                0 && (
                <>
                  {form?.values?.custodianDetails?.servePreferences?.files?.map(
                    (file: { pondFile: FilePondFile }, i: any) => {
                      return (
                        <Grid
                          style={{
                            height: getFileTypeDevHeight(file.pondFile, i),
                          }}
                          item
                          key={i}
                        >
                          <FormControl
                            style={{
                              width: '100%',
                              height: getFileTypeControleHeight(file.pondFile),
                            }}
                            size="small"
                          >
                            <GenericSelectInput
                              name="typeId"
                              label="File Type"
                              disabled={isBusy}
                              options={departmentFileTypes}
                              value={
                                form?.values?.custodianDetails?.servePreferences
                                  ?.files[i]?.typeId
                              }
                              onChange={(e: any) => {
                                autoCheckServePreferencesFields(e);
                                form.setFieldValue(
                                  `custodianDetails.servePreferences.files.${i}.typeId`,
                                  e,
                                );
                              }}
                              onBlur={() => {
                                form.setFieldTouched(
                                  `custodianDetails.servePreferences.files.${i}.typeId`,
                                  true,
                                );
                              }}
                              errorMsg={
                                form?.errors?.custodianDetails?.servePreferences
                                  ?.files?.[i]?.['typeId']
                                  ? form?.errors?.custodianDetails
                                      ?.servePreferences?.files?.[i]?.['typeId']
                                  : ''
                              }
                              hasError={
                                !!form?.errors?.custodianDetails
                                  ?.servePreferences?.files?.[i]?.['typeId']
                              }
                              required={true}
                              small={true}
                            />
                          </FormControl>
                        </Grid>
                      );
                    },
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={1.5}></Grid>
      </Grid>
    </Panel>
  );
}
